import {FC} from 'react';
import {Trans, useTranslation} from 'react-i18next';
import Link from 'components/Link';
import Notification from 'components/Notification';

const DownloadNotificationWarning: FC = () => {
    const {t} = useTranslation('Portal');

    return (
        <Notification className="mt-4" icon="info" type="system">
            <Trans
                components={[
                    <Link
                        key={0}
                        href="https://help.makeleaps.jp/ja/articles/8687205"
                        isOpenInNewTab={true}
                    />,
                ]}
                i18nKey="downloadDocumentModal.includesZipFile"
                t={t}
            />
        </Notification>
    );
};

export default DownloadNotificationWarning;
